import React from "react";
import patientProfileImg from "../../../Assets/Images/patient-profile-img.png";
import starYellow from "../../../Assets/Icons/star-yellow.png";
import starGrey from "../../../Assets/Icons/Star.png";
import rightArrow from "../../../Assets/Icons/right-arrow.svg";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import { getAge } from "../../../Helpers";

const Message = ({ patient, message }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="message">
        <div className="left-msg">
          <div
            // className="profile-img white"
            className="profile-img blue"
            style={{
              border: "2px solid var(--Light-Grey, #eaf0f7)",
              background: "#eaf0f7",
            }}
          >
            {" "}
            <h5 className="h5-400">{`${
              patient.firstName[0] || patient.lastName[0]
            }`}</h5>
          </div>
          <div className="msg-profile">
            <span>{`${patient.firstName} ${patient.lastName}`}</span>
            <div className="msg-labels">
              <span style={{ color: "#676566" }}>{patient.patientId}</span>
              <span
                style={{
                  background: "#EAF0F7",
                  padding: "3px",
                  borderRadius: "2px",
                  width: "30px",
                }}
              >
                {patient.dateOfBirth &&
                  `${getAge(patient.dateOfBirth)}, ${
                    patient.gender && patient.gender[0]
                  }`}
              </span>
              {/* <img
                src={starYellow}
                alt="star"
                style={{ height: "15px", width: "15px" }}
              /> */}
            </div>
          </div>
        </div>
        <div className="right-msg">
          <p
            style={{
              height: "100%",
              lineHeight: "1.4",
              fontSize: "15px",
              overflow: "hidden",
              flex: "1 1 0",
            }}
          >
            {message?.text}
          </p>
          <button
            className="msg-button"
            onClick={() => navigate(`/dashboard/messages/${patient._id}`)}
          >
            Details{" "}
            <img
              src={rightArrow}
              style={{ height: "8px", width: "8px" }}
              alt="arrow"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default Message;
